import React, { useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";

function PalmaresImageModal({ imageUrl, onClose }) {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!imageUrl) return;

    closeButtonRef.current?.focus();

    const handleKeyDown = (keyboardEvent) => {
      if (keyboardEvent.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [imageUrl, onClose]);

  if (!imageUrl) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/85 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <button
        ref={closeButtonRef}
        type="button"
        onClick={onClose}
        className="absolute right-4 top-4 inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15 text-white backdrop-blur-xl transition hover:bg-white/25 focus:outline-none focus:ring-4 focus:ring-white/30"
        aria-label="Fermer"
      >
        <FaTimes />
      </button>

      <img
        src={imageUrl}
        alt="Podium agrandi"
        className="max-h-[88vh] max-w-full rounded-[1.5rem] object-contain shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
}

export default PalmaresImageModal;